import React, { useCallback, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { SyncLoader } from 'react-spinners';
import { FaEnvelope, FaLock } from 'react-icons/fa';
import * as Yup from 'yup';
import CryptoJS from 'crypto-js';

import Button from '~/components/Button';
import Input from '~/components/Input';

import { useAuth } from '~/hooks/auth';
import { useToast } from '~/hooks/toast';

import logoImg from '~/assets/images/logo.png';

import { Container, Content, AnimationContainer } from './styles';

interface IFormAuth {
  email: string;
  password: string;
}

interface ILocation {
  type: string;
  project_id: string;
  project_type: string;
  erp_client_code: string;
}

const schema = Yup.object().shape({
  email: Yup.string().email('E-mail inválido').required('Campo obrigatório'),
  password: Yup.string().required('Campo obrigatório'),
});

const SignIn: React.FC = () => {
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const history = useHistory();
  const { state } = useLocation<ILocation>();
  const [loading, setLoading] = useState<boolean>(false);
  const [valInput, setValInput] = useState('');

  const { handleSubmit, register, errors } = useForm<IFormAuth>({
    resolver: yupResolver(schema),
  });

  const submitForm = useCallback(
    async (data: IFormAuth) => {
      try {
        let passwordValue = '';

        setLoading(true);

        if (process.env.REACT_APP_PASSWORD_CRYPTR_KEY) {
          passwordValue = CryptoJS.AES.encrypt(
            data.password,
            process.env.REACT_APP_PASSWORD_CRYPTR_KEY,
          ).toString();
        }

        if (passwordValue !== '') {
          await signIn({ email: data.email, password: passwordValue });

          if (
            state?.type === 'existing_project' ||
            state?.type === 'new_project'
          ) {
            history.push({
              pathname: '/externalvalidation',
              state,
            });
          } else {
            history.push('/');
          }
        } else {
          addToast({
            type: 'error',
            title: 'Erro na autenticação',
            description: 'Senha inválida',
          });

          setLoading(false);
        }
      } catch (error: any) {
        addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: error.response.data.message,
        });

        setLoading(false);
      }
    },
    [addToast, history, signIn, state],
  );

  return (
    <Container>
      <Content>
        <AnimationContainer>
          <img src={logoImg} alt="Guararapes Logo" />
          <form onSubmit={handleSubmit(submitForm)}>
            <Input
              name="email"
              type="text"
              labelText="E-mail"
              icon={FaEnvelope}
              ref={register}
              error={errors.email?.message}
              validateInput
              onChange={event => setValInput(event.target.value)}
              valueInput={valInput}
            />

            <Input
              name="password"
              labelText="Senha"
              icon={FaLock}
              isPassword
              ref={register}
              error={errors.password?.message}
              validateInput
              onChange={event => setValInput(event.target.value)}
              valueInput={valInput}
            />

            <Button type="button" onClick={handleSubmit(submitForm)}>
              {loading ? (
                <SyncLoader size={8} color="#FFF" margin={4} />
              ) : (
                'Entrar'
              )}
            </Button>
            <a
              href="/resetpassword/request"
              rel="noopener noreferrer"
              target="_blank"
            >
              Esqueceu sua senha?
            </a>
          </form>
        </AnimationContainer>
      </Content>
    </Container>
  );
};

export default SignIn;
